import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import { CartStore } from './slices/types';
import { createImmediateCartSlice } from './slices/immediateCartSlice';
import { createScheduledCartSlice } from './slices/scheduledCartSlice';

export const useCartStore = create<CartStore>()(
  persist(
    (...a) => ({
      ...createImmediateCartSlice(...a),
      ...createScheduledCartSlice(...a),

      // ============ UTILITY METHODS (Shared) ============

      clearAll: () => {
        const [set] = a;
        set({ items: [], offers: [], notes: '', scheduledOrders: [], idempotencyKey: null });
      },

      getTotal: () => {
        const [, get] = a;
        return get().getSubtotal() + get().getService();
      },

      getItemCount: () => {
        const [, get] = a;
        const itemsCount = get().items.reduce((sum, item) => sum + item.quantity, 0);
        const offersCount = get().offers.reduce((sum, item) => sum + item.quantity, 0);
        // Do we count scheduled items in total item count? 
        // Original logic: itemsCount + offersCount. It ignored scheduledOrders for the badge I assume?
        // Let's check original logic in Step 195.
        // Step 195 Line 354: items + offers. Ignored scheduled.
        // So keeping it as is.
        return itemsCount + offersCount;
      },
    }),
    {
      name: 'cart-storage',
      storage: createJSONStorage(() => sessionStorage),
      partialize: (state) => ({
        items: state.items,
        offers: state.offers,
        notes: state.notes,
        scheduledOrders: state.scheduledOrders,
        idempotencyKey: state.idempotencyKey
      })
    }
  )
);